export default __webpack_public_path__ + "static/aljieudum-a74f67e775f626afb9a4d1a7f5cde574.jpg";